import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RecentActivities } from '../../interfaces/dashboard/recent-activities';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RecentActivitiesService {

  constructor(private http: HttpClient) { }

  getRecentActivities(mdmid: string): Observable<RecentActivities[]> {
    return this.http.get<RecentActivities[]>(`Dashboard/ActivitiesByUser?rutDv=${mdmid}`)
      .pipe(map((arr) => arr.filter((row) => new Date(row.createdAt) > new Date(2021, 9, 26))));
  }

  getTaskRequestApprovers(mdmid: string) {
    return this.http.get<TaskUser>(`Task/PendingTaskCountByDriver?rutDv=${mdmid}`);
  }

}

export interface TaskUser {
  pendingTask: number;

}
